import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    filename: String,
    title: String,
    body: String,
    image: String,
    objectid: String,
    citykey: String,
    dlkey: String,
    controller: String,
    url: String
  };

  async share(event) {
    event.preventDefault();

    const files = await this.prepareFiles();
    const url = this.urlValue;
    const shareData = {
      title: this.titleValue,
      text: this.bodyValue,
      url: url || window.location.href,
      files: files.length ? files : [],
    };

    if (files.length && navigator.canShare?.({ files })) {
      shareData.files = files;
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (_) {}
    }
  }

  async prepareFiles() {
    if (!this.hasImageValue) return [];

    try {
      const response = await fetch(this.imageValue);
      const blob = await response.blob();
      const type = blob.type || "image/jpeg";
      const name = this.filenameValue || this.extractFilename(this.imageValue, "image.jpg");

      return [
        new File([blob], name, {
          type,
          lastModified: Date.now()
        })
      ];
    } catch (_) {
      return [];
    }
  }

  extractFilename(url, fallback) {
    const parts = url.split("/");
    let name = parts.pop() || fallback;
    return name.includes(".") ? name : `${name}.jpg`;
  }

  async generateCustomDeepLink() {
    const branch_key = this.dlkeyValue;
    const controller = this.controllerValue || null;
    const city_key = this.citykeyValue || null;
    const objectid = this.objectidValue || null;

    let url =  this.urlValue || null;
    url = url || window.location.href;
    const canonical = controller + "/" + objectid;

    if (!(branch_key && controller && objectid)) {
      return null;
    }

    const dta = {
      "controller": controller,
      "city": city_key,
      "objectID": objectid,
      "$desktop_url": url,
      "$canonicalIdentifier": canonical
    };
    const post_data = {
      'branch_key': branch_key,
      'sdk': 'api',
      'tags': ['4'],
      'data': dta
    };

    try {
      const response = await fetch('https://api.branch.io/v1/url', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(post_data)
      });
      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error("Error generating custom deep link:", error);
      return null;
    }
  }
}
